import { render, staticRenderFns } from "./SuccessfulExchange.vue?vue&type=template&id=28a1aa49&scoped=true"
import script from "./SuccessfulExchange.vue?vue&type=script&lang=js"
export * from "./SuccessfulExchange.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulExchange.vue?vue&type=style&index=0&id=28a1aa49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1aa49",
  null
  
)

export default component.exports